import * as React from 'react';
import { useIntl } from 'react-intl';

import HistorySection from 'Components/HistorySection';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Container, Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistoryRowControls from 'Components/HistoryRowControls';
import InfoPopover from 'Components/InfoPopover';
import { iadl } from 'neuro-schemas';
import { useAppSelector } from 'Store/index';
import { isByInformant } from 'Utility/documentHandling';

const { calculateScore } = iadl;

const IADLHistory = ({ documents, startEdit, handleMyDelete, view }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  const informants = useAppSelector((state: IState) => state.patient.informants) ?? [];

  return (
    <HistorySection
      headerText={fm('diagnosticSurvey.iadl.title')}
      newButton={
        <DocumentCreationButton
          name="iadl"
          text={'diagnosticSurvey.iadl.newIADL'}
          onClick={startEdit({}, 'iadl')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Container>
            <Item xs={true}>{fm('diagnosticSurvey.iadl.score')}</Item>
          </Container>
        }
        contentFormat={d => {
          const isByInf = isByInformant(d, informants);
          return (
            <Container>
              <Item xs={isByInf ? 2 : true}>
                {calculateScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}
              </Item>
              {isByInf ? <Item xs={true}>{fm('diagnosticSurvey.iadl.byInformant')}</Item> : undefined}
            </Container>
          );
        }}
        makeDate
        makeControls
        historyRowControls={d => {
          const isByInf = isByInformant(d, informants);
          return (
            <HistoryRowControls
              document={d}
              startEdit={startEdit}
              view={view}
              enableButtons={isByInf}
              deleteHandler={isByInf ? () => handleMyDelete(d._id, d._type) : undefined}
              hideEditHistory={isByInf}
            />
          );
        }}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'iadl'>[];
  startEdit: StartEdit<IDocumentWithTypeV2<'iadl'>>;
  handleMyDelete: (myDocId: string, docType: TMyDocumentType) => Promise<void>;
  view?: IView;
}

export default IADLHistory;
